import { Route } from 'react-router-dom';

import { PaymentPolicyDetailPage } from './pages/payment-policy-detail-page.js';
import { PaymentPolicyFormPage } from './pages/payment-policy-form-page.js';
import { PaymentPolicyListPage } from './pages/payment-policy-list-page.js';

/**
 * The module's routes, owned by the module.
 *
 * Returned as a fragment of `<Route>` elements so the app's router composes
 * modules rather than enumerating every screen in one file.
 */
export function paymentPolicyRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/payment-policies" element={<PaymentPolicyListPage />} />
      {/* Before the parameterised detail route: react-router ranks a static
          segment above a dynamic one, but keeping them in this order means a
          reader does not have to know that to see which wins. */}
      <Route path="/payment-policies/new" element={<PaymentPolicyFormPage />} />
      <Route path="/payment-policies/:policyId/edit" element={<PaymentPolicyFormPage />} />
      <Route path="/payment-policies/:policyId" element={<PaymentPolicyDetailPage />} />
    </>
  );
}
